// extracted by mini-css-extract-plugin
export default {"btnMargin":"cash_btnMargin__pzOxJ","btnPadding":"cash_btnPadding__tuE-l","textArea":"cash_textArea__EwtzP","balance":"cash_balance__-U15u"};